import { faMessage } from '@fortawesome/pro-light-svg-icons/faMessage'
import { Icon } from 'src/components'
import i18n from 'src/i18n'

export type CounterCommentsProps = {
  counter: number
}

const CounterComments = ({ counter }: CounterCommentsProps) => {
  const getCounterLabel = () => {
    return counter === 1
      ? i18n.t('comments.comment_one', { count: counter })
      : i18n.t('comments.comment_other', { count: counter })
  }

  const counterLabel = getCounterLabel()

  return (
    <div className="_text-gray-700 _text-1 _d-flex">
      <div className="_mr-2">
        <Icon icon={faMessage} />
      </div>
      <div data-test="counter-comment">{counterLabel}</div>
    </div>
  )
}

export default CounterComments
